var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
export var sortArray = function (field, altField) { return function (a, b) {
    // Use 'field' if it exists, otherwise use 'altField', makes an array sortable by using one field if exists otherwise fallback to a "default" field
    var aField = altField;
    var bField = altField;
    if (a[field]) {
        aField = field;
    }
    if (b[field]) {
        bField = field;
    }
    if (typeof a[aField] === 'string' && typeof b[bField] === 'string') {
        if (a[aField].toLowerCase() < b[bField].toLowerCase()) {
            return -1;
        }
        if (a[aField].toLowerCase() > b[bField].toLowerCase()) {
            return 1;
        }
        return 0;
    }
    if (a[aField] < b[bField]) {
        return -1;
    }
    if (a[aField] > b[bField]) {
        return 1;
    }
    return 0;
}; };
export var generateShortUUID = function () {
    return "".concat(new Date().valueOf()).concat(Math.random().toString(36).substring(2, 15));
};
export var generateUUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 || 0;
        var v = c === 'x' ? r : (r && 0x3) || 0x8;
        return v.toString(16);
    });
};
export var debounce = function (func, wait, immediate) {
    var timeout = null;
    return function debouncedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var context = this;
        var later = function later() {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
};
/*eslint-disable*/
export function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options)
        options = {};
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout)
            context = args = null;
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false)
            previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout)
                context = args = null;
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}
/* eslint-enable */
export var enterText = function (wrapper, id, value) {
    wrapper.find("#".concat(id)).simulate('change', {
        target: { name: id, value: value },
    });
};
var componentToHex = function (c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
};
export var rgbToHex = function (rgb) {
    return "#".concat(componentToHex(rgb.r)).concat(componentToHex(rgb.g)).concat(componentToHex(rgb.b));
};
export var hexToHsl = function (hex) {
    if (!hex) {
        return null;
    }
    var r;
    var g;
    var b;
    if (typeof hex === 'object') {
        /* eslint-disable prefer-destructuring */
        r = hex.r;
        g = hex.g;
        b = hex.b;
        /* eslint-enable prefer-destructuring */
    }
    else {
        r = parseInt(hex.substr(1, 2), 16) / 255;
        g = parseInt(hex.substr(3, 2), 16) / 255;
        b = parseInt(hex.substr(5, 2), 16) / 255;
    }
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                return null;
        }
        h /= 6;
    }
    h = Math.round(h * 360);
    s = Math.round(s * 100);
    l = Math.round(l * 100);
    return {
        h: h,
        s: s,
        l: l,
    };
};
export var fontSizeRange = function (start, end) {
    var arr = [];
    for (var i = start; i <= end; i += 1) {
        if (i % 2 === 0) {
            arr.push(i);
        }
    }
    return arr;
};
export var fontSpacingRange = function (start, end) {
    var arr = [];
    for (var i = start; i <= end; i += 1) {
        arr.push(i);
    }
    return arr;
};
export var stringSearch = function (rows, searchQuery) {
    if (!rows || !searchQuery) {
        return null;
    }
    return rows.filter(function (row) {
        return Object.values(row).some(function (cell) {
            return cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase());
        });
    });
};
export var functionDelay = function (ms) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, ms);
    });
};
export var objDiff = function (originalObj, newObj) {
    return transform(originalObj, function (result, value, key) {
        if (!isEqual(newObj[key], value)) {
            result[key] = value;
        }
    }, {});
};
export var capitalizeFirst = function (text) {
    return text && text.charAt(0).toUpperCase() + text.slice(1);
};
// Crumber, gets an integer and the current path and text and recursively creates
// the number of crumbs specified
export var crumber = function (i, to, toText, skip) {
    // add current path
    var crumbs = [{ to: to, text: toText }];
    skip = skip ? -skip - 1 : -1;
    // prepend the next path for each iteration
    for (i; i > 0; i--) {
        to = to.split('/').slice(0, skip).join('/');
        var text = capitalizeFirst(to.split('/').pop());
        crumbs.unshift({ to: to, text: text });
    }
    crumbs[crumbs.length - 1].to = '';
    return crumbs;
};
export var groupIdName = function (groupId) {
    return capitalizeFirst(groupId.substring(groupId.lastIndexOf(':') + 1, groupId.length));
};
// Name should only include small letters, numbers and underscores
var nameRegexp = new RegExp(/^[a-z0-9_]*$/);
export var isValidName = function (name) { return nameRegexp.test(name); };
var urlRegexp = new RegExp(/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/);
export var isValidURL = function (url) { return urlRegexp.test(url); };
export var createSearchQuery = function (queryArray) {
    var queryString = '';
    queryArray.forEach(function (query) {
        queryString += "".concat(query.key, "=").concat(query.operation.operation, ".").concat(query.value, "&");
    });
    return queryString;
};
export var stripHtml = function (value) {
    return typeof value === 'string' ? value.replace(/(<([^>]+)>)/gi, '') : value;
};
// make the default group names prettier
export var prettyAppGroupName = function (name) {
    switch (name) {
        case 'users':
            return 'App Users';
        case 'anonymous':
            return 'Anonymous App Users';
        case 'registered':
            return 'Registered App Users';
        case 'appowner':
            return 'App Owner';
        case 'groupappmanager':
            return 'App Manager';
        case 'contentagent':
            return 'Content Agent';
        default:
            return capitalizeFirst(name);
    }
};
/** takes "?key=value&key2=value2" and formats into an object with
 * {key: value, key2: value2 } */
export var buildQueryParamsFromSearch = function (search) {
    if (search === void 0) { search = ''; }
    return (search.replace('?', '').split('&') || []).reduce(function (acc, pair) {
        var _a = pair.split('='), key = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
        if (key) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
export var parseQueryParams = function (_a) {
    var _b = _a.search, search = _b === void 0 ? '' : _b;
    if (!search) {
        return null;
    }
    return buildQueryParamsFromSearch(search);
};
// decode the app id from token
export var appIdFromToken = function (token) {
    var payload = token && token.split('.')[1];
    if (payload) {
        try {
            var decodedPayload = JSON.parse(atob(payload));
            return (decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.app) || null;
        }
        catch (err) {
            console.error(err);
        }
    }
    return null;
};
// decode the signup id from token
export var signupIdFromToken = function (token) {
    var payload = token && token.split('.')[1];
    if (payload) {
        try {
            var decodedPayload = JSON.parse(atob(payload));
            return (decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.signupId) || null;
        }
        catch (err) {
            console.error(err);
        }
    }
    return null;
};
export var setAppIcon = function (rel, icon, sizes) {
    if (sizes === void 0) { sizes = null; }
    var mobileIcon = document.createElement('link');
    mobileIcon.rel = rel;
    mobileIcon.href = icon;
    if (sizes) {
        mobileIcon.sizes = sizes;
    }
    document.getElementsByTagName('head')[0].appendChild(mobileIcon);
};
export var prettyDate = function (date) { return moment(date).format('DD/MM/YYYY'); };
export var truncate = function (input, maxLength) {
    if (input === void 0) { input = ''; }
    if (maxLength === void 0) { maxLength = 0; }
    return input.length > maxLength ? "".concat(input.substring(0, maxLength), "...") : input;
};
export var roundTo2 = function (number) {
    if (number === void 0) { number = 0; }
    return Math.floor(number * 100) / 100;
};
// Rename object key (non mutating) and optionally put a new value into renamed key
export var renameObjKey = function (oldKey, // old key name
newKey, // new key name
_a, // target object
newValue) {
    var _b;
    var _c = oldKey, oldK = _a[_c], rest = __rest(_a, // new key name
    [typeof _c === "symbol" ? _c : _c + ""]);
    return (__assign((_b = {}, _b[newKey] = newValue !== undefined ? newValue : oldK, _b), rest));
};
// Rename object key (non mutating) and optionally put a new value into renamed key,
// preserving the order of the object keys
export var renameObjKeyOrderPreserved = function (oldKey, // old key name
newKey, // new key name
obj, // target object
newValue) {
    var keys = Object.keys(obj);
    var newObj = keys.reduce(function (acc, val) {
        if (val === oldKey) {
            acc[newKey] = newValue !== undefined ? newValue : obj[oldKey];
        }
        else {
            acc[val] = obj[val];
        }
        return acc;
    }, {});
    return newObj;
};
export var convertDatasetTypesToViewTypes = function (fields) {
    return Object.values(fields).map(function (field) {
        var _a;
        var type;
        switch ((_a = field === null || field === void 0 ? void 0 : field.typeRow) === null || _a === void 0 ? void 0 : _a.type) {
            case 'string':
            case 'richText':
                type = 'text';
                break;
            case 'integer':
            case 'float':
                type = 'number';
                break;
            case 'time':
                type = 'timestamp';
                break;
            case 'location':
                type = 'coordinates';
                break;
            default:
                (type = field.typeRow.type);
                break;
        }
        return {
            id: generateUUID().slice(0, 10),
            name: field.name,
            type: type,
        };
    });
};
/** createSearchFunction creates a function that
 *  multi filters a list given searchable keys */
export var createSearchFunction = function (searchable) {
    if (searchable === void 0) { searchable = []; }
    return function (query, list) {
        if (query === void 0) { query = ''; }
        if (list === void 0) { list = []; }
        var parsedQuery = query.toLowerCase().trim().split(' ');
        if (!parsedQuery) {
            return list;
        }
        var filteredList = __spreadArray([], list, true);
        var _loop_1 = function (q) {
            if (q !== '') {
                filteredList = filteredList.filter(function (i) {
                    return searchable.some(function (key) {
                        return "".concat(i[key]).toLowerCase().includes("".concat(q).trim());
                    });
                });
            }
        };
        for (var _i = 0, parsedQuery_1 = parsedQuery; _i < parsedQuery_1.length; _i++) {
            var q = parsedQuery_1[_i];
            _loop_1(q);
        }
        return filteredList;
    };
};
export var dateFormat = function (number) {
    switch (number) {
        case 1:
        case 21:
            return number + 'st';
            break;
        case 2:
        case 22:
            return number + 'nd';
            break;
        case 3:
        case 23:
            return number + 'rd';
            break;
        default:
            return number + 'th';
    }
};
